import React from "react";
import { useDrop } from "react-dnd";
import { makeStyles } from "@material-ui/core/styles";
import { BaseType, VehicleType, BASE_DROP_TARGET_TYPE } from "./types";
import VehicleItem from "./VehicleItem";
import clsx from "clsx";
import _ from "lodash";

interface BlockProps {
  base: BaseType;
  vehicles: VehicleType[];
  dragDropAction: any;
}

const useStyles = makeStyles(() => ({
  root: {
    breakInside: "avoid",
    backgroundColor: "#E8E8E8",
    borderRadius: "4px",
    padding: "14px 22px 0 22px",
    flexDirection: "column",
    marginBottom: "18px",
    minHeight: 147,
  },
  over: {
    backgroundColor: "#c7c7c7",
  },
  baseName: {
    color: "#333",
    fontSize: "19px",
    fontWeight: 900,
    marginBottom: 17,
  },
  vehicleList: {
    display: "flex",
    flexWrap: "wrap",
  },
}));

const BaseBlock: React.FC<BlockProps> = ({ base, vehicles, dragDropAction }): JSX.Element => {
  const style = useStyles();

  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: BASE_DROP_TARGET_TYPE,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    drop: (item: any, monitor: any) => {
      dragDropAction({
        vehicle: item,
        newBaseId: base.baseId,
      });
    },
  }));

  return (
    <div
      className={clsx(style.root, {
        [style.over]: isOver,
      })}
      ref={drop}
    >
      <div className={style.baseName}>{base.baseName}</div>
      <div className={style.vehicleList}>
        {vehicles.map((v) => (
          <VehicleItem key={v.vehicleId} vehicle={v} />
        ))}
      </div>
    </div>
  );
};

export default BaseBlock;
